import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


export var gql_GetApplicationsByAsset = gql`
  query getAssetApplications($organizationId: UUID!, $assetId: UUID!) {
   applicationsByAsset(organizationId: $organizationId, assetId: $assetId) 
   {
    id
     id_friendly
     application_status
     application_status_id
     deposit_paid
     signed
     pm_status
   created_ts
   }
  }
`;



export function apiGetAssetApplications(organizationId, assetId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: gql_GetApplicationsByAsset,
                variables: {organizationId, assetId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.applicationsByAsset);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset applications");
                reject(err); // R
            })
    });
}
